import { render } from "./KpiStrip.vue?vue&type=template&id=33c267bd&scoped=true"
import script from "./KpiStrip.vue?vue&type=script&lang=js"
export * from "./KpiStrip.vue?vue&type=script&lang=js"

import "./KpiStrip.vue?vue&type=style&index=0&id=33c267bd&scoped=true&lang=css"

import exportComponent from "/home/runner/work/acp-portal-frontend/acp-portal-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33c267bd"]])

export default __exports__